import t from"styled-components";const e=t.div`
	display: grid;
	place-content: center;
`;export{e as PaginationContainer};
